/* eslint-disable react/no-array-index-key */

import React, { type ReactNode } from 'react';
import type { AdditionalSummaryLine as AdditionalSummaryLineModel, BasketAdditionalSummary } from 'autogen/swagger/all';
import AdditionalSummaryLine from './AdditionalSummaryLine';

type AdditionalSummaryRenderer = Record<string, any> & {
    model: BasketAdditionalSummary;
    renderer?: (model: AdditionalSummaryLineModel, props) => ReactNode;
};

export default function AdditionalSummaryRenderer({
    model: { additionalSummaryLines },
    renderer = (additionalSummaryLine, props) => <AdditionalSummaryLine {...props} model={additionalSummaryLine} />,
    ...restProps
}: AdditionalSummaryRenderer) {
    return (
        <>
            {additionalSummaryLines.map((additionalSummaryLine, index) => (
                <React.Fragment key={index}>{renderer(additionalSummaryLine, restProps)}</React.Fragment>
            ))}
        </>
    );
}
